import styled from 'styled-components';
import { mt, mr } from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

export const StyledLabel = styled.label`
  ${mr(4.5)}
  ${mt(2)}

  cursor: pointer;
  font-weight: 600;
  position: relative;
  display: flex;
  align-items: center;

  &:last-child {
    ${mr(0)}
  }
`;

export const StyledInput = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
`;

export const StyledDotsContainer = styled.div`
  ${mr(3)}

  position: relative;
  display: inline-block;
  width: ${({ box }) => (box ? '38px' : '24px')};
  height: ${({ box }) => (box ? '38px' : '24px')};
`;

export const StyledDotOuter = styled.span`
  position: absolute;
  box-sizing: content-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 1px solid ${colors.translucentDarkBlue};
  ${({ noBorder }) => noBorder && 'border: none'};
  ${({ light }) => light && `background-color: ${colors.lightGray};`}
  background-color: ${props => (props.light ? colors.lightGray : colors.greyBlue10)};
  border-radius: ${({ box }) => (box ? '4px' : '50%')};
  ${({ box }) => box && `background-color: ${colors.lightGray};`}
`;

export const StyledDotInner = styled.span`
  display: none;
  position: absolute;
  left: 4px;
  top: 4px;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border-radius: ${({ box }) => (box ? '4px' : '50%')};
  background-position: center;
  background-repeat: no-repeat;

  
  ${({ box }) => !box && 'background-color: black;'}
  ${({ box }) => box && 'background-image: url(/static/icons/tick.svg);'}
  

  ${StyledInput}:checked ~ ${StyledDotsContainer} & {
    display: inline;
  }
`;
